import { render } from "./AdminSubscriptionInfoDialog.vue?vue&type=template&id=b5925b24"
import script from "./AdminSubscriptionInfoDialog.vue?vue&type=script&lang=js"
export * from "./AdminSubscriptionInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__